import { ds24_unique_id } from '../common/ds24_unique_id';

export function ds24cart_element_id( obj: HTMLElement )
{
    var obj_id = obj.getAttribute('id');
    if (!obj_id) {
        obj_id = ds24_unique_id( 'id' );
        obj.setAttribute('id', obj_id);
    }
    return obj_id;
}